import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CardComponent } from '../core/panels/card.component';
@Component({
  selector: 'app-card-design',
  imports: [CommonModule, RouterModule, CardComponent],
  template: `
    <div class="tw-w-full tw-flex tw-gap-4">
      <app-card label="Large" class="tw-basis-1/4" type="Large">
        <div>one</div>
      </app-card>
      <app-card label="Medium" class="tw-basis-1/4" type="Medium">
        <div>one</div>
      </app-card>

      <app-card label="Small" class="tw-basis-1/4">
        <div>one</div>
      </app-card>
    </div>
    <div class="tw-w-full tw-flex tw-gap-4 tw-pt-4">
      <app-card label="Large" class="tw-basis-1/4" type="Large" theme="Light">
        <div>one</div>
      </app-card>
      <app-card label="Medium" class="tw-basis-1/4" type="Medium" theme="Light">
        <div>one</div>
      </app-card>

      <app-card label="Small" class="tw-basis-1/4" theme="Light">
        <div>one</div>
      </app-card>
    </div>
  `,
  styles: ``,
})
export class CardDesignComponent {}
